import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-principais-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-tamanho-completo" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Novo", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  style: {"height":"calc(100% - 60px)"},
  class: "ss-card ss-card-space ss-tela-conteudo-completo"
}
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS:")
], -1)
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-13" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "PERÍODO:")
], -1)
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_14 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_filtro_periodo_movimento_comercial = _resolveComponent("selecionar-filtro-periodo-movimento-comercial")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_card = _resolveComponent("card")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_kanban = _resolveComponent("kanban")!
  const _component_recebimento_mercadorias_listagem = _resolveComponent("recebimento-mercadorias-listagem")!
  const _component_recebimento_mercadorias_modal = _resolveComponent("recebimento-mercadorias-modal")!
  const _component_selecionar_origem_recebimento_mercadorias_modal = _resolveComponent("selecionar-origem-recebimento-mercadorias-modal")!
  const _component_lancamento_rastreabilidade_modal = _resolveComponent("lancamento-rastreabilidade-modal")!
  const _component_conhecimento_transporte_modal = _resolveComponent("conhecimento-transporte-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: _ctx.telaBase.identificadorRecurso,
          tituloRecurso: "Recebimentos de Mercadorias",
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: [_ctx.state.empresaSelecionada]
        }, {
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.state.qtdSelecionadosConcluir > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Concluir Etapa",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.concluirEtapa && _ctx.concluirEtapa(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "check" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdSelecionadosRetomar > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Retornar Etapa",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.retornarEtapa && _ctx.retornarEtapa(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "rollback" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdSelecionados > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Imprimir",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "imprimir" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdSelecionadosCancelar > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Cancelar",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "cancelar" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdSelecionadosExcluir > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Excluir",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "excluir" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.telaBase.permissaoDados.incluir)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      type: "button",
                      class: "ant-btn ant-btn-primary ss-btn-tela",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selecionarOrigem && _ctx.selecionarOrigem(...args)))
                    }, _hoisted_7))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["identificadorRecurso", "empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_card, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_select, {
                    value: _ctx.state.empresaSelecionada,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.empresaSelecionada) = $event)),
                    options: _ctx.telaBase.empresasDisponiveis,
                    style: {"width":"100%"},
                    optionFilterProp: "label",
                    onChange: _ctx.atualizarSelecaoEmpresas,
                    disabled: _ctx.telaBase.empresasDisponiveis.length === 1
                  }, null, 8, ["value", "options", "onChange", "disabled"])
                ]),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_selecionar_filtro_periodo_movimento_comercial, {
                    valor: _ctx.state.filtroPeriodo,
                    "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.filtroPeriodo) = $event)),
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.periodoAlterado()))
                  }, null, 8, ["valor"]),
                  ((_ctx.state.filtroPeriodo === _ctx.EFiltroPeriodoMovimentoComercial.Personalizado))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_a_form_item, {
                            label: "Data Inicial e Final",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data_inicial_final, {
                                dataInicialSelecionada: _ctx.state.dataInicialSelecionada,
                                "onUpdate:dataInicialSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.dataInicialSelecionada) = $event)),
                                dataFinalSelecionada: _ctx.state.dataFinalSelecionada,
                                "onUpdate:dataFinalSelecionada": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.dataFinalSelecionada) = $event))
                              }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_busca_geral, {
                empresas: [_ctx.state.empresaSelecionada],
                ordenacao: _ctx.telaBase.ordenacaoSelecionada,
                "onUpdate:ordenacao": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                buscaRapida: _ctx.state.buscaRapida,
                "onUpdate:buscaRapida": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                buscaAvancada: _ctx.state.buscaAvancada,
                "onUpdate:buscaAvancada": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.buscaAvancada) = $event)),
                onBuscarDados: _ctx.buscarRecebimentos
              }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados"])
            ]),
            _: 1
          }),
          _createVNode(_component_card, { style: {"height":"calc(100vh - 225px)","margin-bottom":"0px"} }, {
            default: _withCtx(() => [
              (_ctx.state.visualizarKanban)
                ? (_openBlock(), _createBlock(_component_kanban, {
                    key: 0,
                    titulo: "",
                    style: {"height":"calc(100vh - 270px)"},
                    switchListagem: true,
                    colunas: _ctx.state.colunas,
                    "onUpdate:colunas": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.colunas) = $event)),
                    visualizacaoKanban: _ctx.state.visualizarKanban,
                    "onUpdate:visualizacaoKanban": [
                      _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.visualizarKanban) = $event)),
                      _ctx.buscarRecebimentos
                    ],
                    onClickVisualizar: _ctx.clickEditar,
                    onColunaCardAlterada: _ctx.moverCard,
                    onSelecaoCardAlterada: _ctx.selecionarCard,
                    onQtdSelecaoAlterada: _ctx.atualizarSelecionados,
                    onOrdemCardsAlterada: _ctx.atualizarOrdemCards
                  }, {
                    menus: _withCtx(() => [
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clickEditar && _ctx.clickEditar(...args)))
                          }, "Visualizar")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.imprimirDetalhado(Number(_ctx.state.cardSelecionado))))
                          }, "Imprimir")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["colunas", "visualizacaoKanban", "onClickVisualizar", "onColunaCardAlterada", "onSelecaoCardAlterada", "onQtdSelecaoAlterada", "onOrdemCardsAlterada", "onUpdate:visualizacaoKanban"]))
                : (_openBlock(), _createBlock(_component_recebimento_mercadorias_listagem, {
                    key: 1,
                    recebimentos: _ctx.state.recebimentos,
                    "onUpdate:recebimentos": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.recebimentos) = $event)),
                    paginacao: _ctx.state.paginacao,
                    "onUpdate:paginacao": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.paginacao) = $event)),
                    visualizacaoKanban: _ctx.state.visualizarKanban,
                    "onUpdate:visualizacaoKanban": [
                      _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.visualizarKanban) = $event)),
                      _ctx.buscarRecebimentos
                    ],
                    selecionados: _ctx.state.selecionados,
                    "onUpdate:selecionados": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.selecionados) = $event)),
                    onVisualizar: _ctx.editarRecebimento,
                    onNovoLancamento: _ctx.selecionarOrigem,
                    onBuscarRecebimentos: _ctx.buscarRecebimentos,
                    onSelecaoAlterada: _ctx.atualizarSelecionadosKanban,
                    onImprimir: _ctx.imprimirDetalhado
                  }, null, 8, ["recebimentos", "paginacao", "visualizacaoKanban", "selecionados", "onVisualizar", "onNovoLancamento", "onBuscarRecebimentos", "onSelecaoAlterada", "onUpdate:visualizacaoKanban", "onImprimir"]))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_recebimento_mercadorias_modal, {
      operacao: _ctx.state.operacaoLancamento,
      origem: _ctx.state.origemSelecionada,
      visivel: _ctx.state.exibirLancamento,
      "onUpdate:visivel": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
      onConfirmacao: _cache[23] || (_cache[23] = ($event: any) => (_ctx.buscarRecebimentos())),
      recebimentoMercadoriaImportacao: _ctx.state.recebimentoMercadoriaImportacao
    }, null, 8, ["operacao", "origem", "visivel", "recebimentoMercadoriaImportacao"]),
    _createVNode(_component_selecionar_origem_recebimento_mercadorias_modal, {
      empresa: _ctx.state.empresaSelecionada,
      visivel: _ctx.state.exibirSelecionarOrigem,
      "onUpdate:visivel": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.exibirSelecionarOrigem) = $event)),
      onOrigemEscolhida: _ctx.incluir,
      onContinuarImportacaoRecebimento: _ctx.incluirRecebimentoImportado
    }, null, 8, ["empresa", "visivel", "onOrigemEscolhida", "onContinuarImportacaoRecebimento"]),
    (_openBlock(), _createBlock(_component_lancamento_rastreabilidade_modal, {
      key: _ctx.state.keyLancamentoRastreabilidade,
      empresa: _ctx.state.empresaSelecionada,
      visivel: _ctx.state.lancarRastreabilidade,
      "onUpdate:visivel": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.lancarRastreabilidade) = $event)),
      lancouRastreabilidade: _ctx.state.lancouRastreabilidade,
      "onUpdate:lancouRastreabilidade": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.lancouRastreabilidade) = $event)),
      codigoDefinicaoProduto: _ctx.state.codigoProdutoSelecionado,
      itemEstoque: _ctx.state.codigoItemEstoqueSelecionado,
      recurso: 'RECEBIMENTOS_MERCADORIAS',
      quantidade: _ctx.state.quantiddadeSelecionado,
      codigoOperacao: _ctx.state.codigoItemSelecionado,
      rastreabilidades: _ctx.state.rastreabilidades,
      "onUpdate:rastreabilidades": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.rastreabilidades) = $event)),
      codigoTipoOperacao: _ctx.state.numeroNotaSelecionado,
      codigoUnidade: _ctx.state.codigoUnidadeSelecionado,
      fatorConversao: _ctx.state.fatorConversaoSelecionado,
      siglaUnidade: _ctx.state.siglaUnidadeSelecionado
    }, null, 8, ["empresa", "visivel", "lancouRastreabilidade", "codigoDefinicaoProduto", "itemEstoque", "quantidade", "codigoOperacao", "rastreabilidades", "codigoTipoOperacao", "codigoUnidade", "fatorConversao", "siglaUnidade"])),
    (_ctx.state.exibirCTe)
      ? (_openBlock(), _createBlock(_component_conhecimento_transporte_modal, {
          key: 0,
          empresa: _ctx.state.empresaSelecionada,
          operacao: _ctx.state.operacaoLancamento,
          visivel: _ctx.state.exibirCTe,
          "onUpdate:visivel": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.exibirCTe) = $event)),
          onConfirmacao: _cache[29] || (_cache[29] = ($event: any) => (_ctx.buscarRecebimentos()))
        }, null, 8, ["empresa", "operacao", "visivel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ]))
}